export default function(_) {
  return Object.prototype.toString.call(_) === '[object Date]';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-util/src/isDate.js
// module id = 227
// module chunks = 0